import { Pressable } from 'react-native'
import { styled } from '~/utils'

export const Item = styled(Pressable, theme => {
  return {
    base: {
      minWidth: 184,
      maxWidth: '100%',
      borderColor: theme.colorContainerBorderDefault,
      borderWidth: theme.borderWidthQuarterpulse,
      borderRadius: theme.borderRadiusMediumcontainer,
      padding: theme.spacingInlineFourpulse,
      backgroundColor: theme.colorContainerFillDefault,
    },
    variants: {
      disabled: {
        true: {
          backgroundColor: theme.colorContainerFillDisabled,
          borderColor: theme.colorContainerBorderDisabled,
        },
      },
    },
  }
})
